import { Outlet, Navigate } from "react-router-dom";
import React, { useContext } from "react";
import { useAuthState } from "./providers/AuthStateProvider";
import { BarbershopContext } from "./providers/useProvider";
const PrivateRoutes = () => {
  let auth = { token: false };
  const { user } = useAuthState();
  const { config } = useContext(BarbershopContext);
  return user.token != null && user != null ? (
    <Outlet />
  ) : (
    <Navigate to={`/`} />
  );
};

export default PrivateRoutes;
